const PublicLayout = ({ children }) => {
  return (
    <div className="public-layout bg-[#EBEBEB] min-h-screen">
      <main className="mx-auto w-full max-w-[1920px]">{children}</main>
    </div>
  );
};

export default PublicLayout;